import { createStore } from "vuex";
import axios from "axios";
import { Toast } from "vant";
import { Object } from "core-js";
import moment from "moment";

axios.defaults.withCredentials = true;

const tip = (msg) => {
  Toast({
    message: msg,
    duration: 1000,
    forbidClick: true,
  });
};

let baseURL;
if (process.env.NODE_ENV !== "production") {
  baseURL = "api/week";
} else {
  baseURL = "https://zsrbactivity.zsnews.cn";
}

export default createStore({
  state: {
    checked: [],
    envData: {},
    jsBridgePackage: {},
    homeImgs: [],
    statement: "",
    showStatement: false,
    candidates: [],
    rank: [],
    countDown: 0,
    user: {},
    leftVoteNum: 0,
    selectedVoteNum: 0,
    voteLoading: false,
    applyStarttime: 0,
    activityImg: [],
    award: "",
    termsList: [],
    voteStartTime: "",
    voteEndTime: "",
    covers: [],
    activityIamge: [],
    canVote: false,
    startTime: "",
    endTime: "",
    termId: "",
    voteNum: "",
  },
  mutations: {
    //选择了哪些老师
    updateChecked(state, checked) {
      state.checked = checked;
    },
    updateHomeImgs(state, homeImgs) {
      state.homeImgs = homeImgs;
    },
    updateShowStatement(state, showStatement) {
      state.showStatement = showStatement;
    },
    updateStatement(state, statement) {
      state.statement = statement;
    },
    initialCandidates(state, candidates) {
      candidates.forEach((candidate) => {
        candidate.my_vote = 0;
      });
      state.candidates = candidates;
    },
    updateCandidates(state, candidates) {
      state.candidates = candidates;
    },
    updateTerms(state, terms) {
      state.termsList = terms;
      var curtime = Date.parse(new Date());
      state.termsCurtime = curtime;
      console.log(curtime);
      console.log(terms);
    },
    updateImage(state, iamge) {
      state.activityIamge = iamge;
    },
    updateEnvData(state, envData) {
      state.envData = envData;
      var curtime = Date.parse(new Date());
      state.curtime = curtime;
      state.countDown = envData.applyEndtime * 1000 - curtime;
      state.applyStarttime = envData.applyStarttime * 1000;
      state.applyEndtime = envData.applyEndtime * 1000;
      state.startTime = moment(state.applyStarttime).format("MM.DD");
      state.endTime = moment(state.applyEndtime).format("MM.DD");
      state.statement = envData.statement;
      state.covers = envData.covers;
      // state.canVote = envData.canVote > 0;
      console.log(envData.voteNum);
      console.log(envData.maxNum);
      state.voteNum = envData.voteNum;
      state.leftVoteNum = envData.voteNum / envData.maxNum;
      state.maxNum = envData.maxNum;
      state.award = envData.awardInformation;
      state.termId = envData.termId;
    },
    updateJsBridgePackage(state, jsBridgePackage) {
      state.jsBridgePackage = jsBridgePackage;
    },
    updateRank(state, rank) {
      state.rank = rank;
    },
    updateUser(state, user) {
      state.user = user;
      const { aplus_queue } = window;
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["_user_id", user.user_id],
      });
    },
    updateLeftVoteNum(state, leftVoteNum) {
      state.leftVoteNum = leftVoteNum;
    },
    updateMaxNum(state, maxNum) {
      state.maxNum = maxNum;
    },
    updateAward(state, award) {
      state.award = award;
    },
    minusLeftVoteNum(state) {
      state.leftVoteNum++;
      state.selectedVoteNum--;
    },
    plusLeftVoteNum(state) {
      state.leftVoteNum--; //点赞数
      state.selectedVoteNum++;
    },
    updateSelectedVoteNum(state, selectedVoteNum) {
      state.selectedVoteNum = selectedVoteNum;
    },
    updateVoteLoading(state, voteLoading) {
      state.voteLoading = voteLoading;
    },
    updateCanVote(state, canVote) {
      state.canVote = canVote;
      if (!canVote) {
        state.leftVoteNum = 0;
      }
    },
  },
  actions: {
    // 投票活动基础信息
    getAppEnv({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        axios
          .get(baseURL + "/api/week/voteindex", { params })
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 1) {
                commit("updateEnvData", data.data);
                commit("updateImage", data.data.voteImages);
                resolve(data);
              } else {
                tip(data.msg);
                reject();
              }
            } else {
              tip("网络错误，请重试");
              reject();
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
            reject();
          });
      });
    },
    // 档期列表
    getTerms({ commit }) {
      axios
        .get(baseURL + "/api/week/terms")
        .then((res) => {
          if (res.status === 200) {
            const data = res.data;
            if (data.code === 1) {
              commit("updateTerms", data.data);
            } else {
              tip(data.msg);
            }
          } else {
            tip("网络错误，请重试");
          }
        })
        .catch(() => {
          tip("网络错误，请重试");
        });
    },
    // 候选人列表
    getCandidates({ commit, state }, { params, loading, finished }) {
      console.log(state.termId);
      axios
        .get(baseURL + "/api/week/candidates", {
          params: params,
        })
        .then((res) => {
          //to-do 分页处理
          //接口需要传当前页码，总页数
          //假如是第一页情况数组，插入数据，假如不是第一页则直接插入数据
          loading.value = false;
          finished.value = true;
          if (res.status === 200) {
            const data = res.data;
            if (data.code === 1) {
              // commit("updateCandidates", data.data.candidates);
              commit("initialCandidates", data.data.candidates);
              console.log("=====jjjjj");
              console.log(data.data.candidates);
            } else {
              tip(data.msg);
            }
          } else {
            tip("网络错误，请重试");
          }
        })
        .catch(() => {
          tip("网络错误，请重试");
        });
    },
    //排行榜
    getRank({ commit }, { params }) {
      axios
        .get(baseURL + "/api/week/rank", { params: params })
        .then((res) => {
          if (res.status === 200) {
            const data = res.data;
            if (data.code === 1) {
              commit("updateRank", data.data);
            } else {
              tip(data.msg);
            }
          } else {
            tip("网络错误，请重试");
          }
        })
        .catch(() => {
          tip("网络错误，请重试");
        });
    },
    // 获取能否投票 需登录?token=895840a1-345a-4752-900a-0158cfeecde1
    getCanVote({ commit }, { params }) {
      console.log(params);
      axios
        .get(baseURL + "/api/week/canVote", { params: params })
        .then((res) => {
          console.log(res);
          if (res.status === 200) {
            const data = res.data;
            if (data.code === 1) {
              console.log(data);
              commit("updateCanVote", data.data.canVote > 0);
            } else {
              tip(data.msg);
            }
          } else {
            tip("网络错误，请重试");
          }
        })
        .catch(() => {
          tip("网络错误，请重试");
        });
    },
    multyVote({ commit, state }, id) {
      let multyChecked = {};
      state.candidates.forEach((candidate) => {
        multyChecked[candidate.id] = candidate.my_vote;
      });
      console.log("multyChecked", multyChecked);
      const sum = Object.values(multyChecked).reduce((a, b) => a + b);
      if (sum <= 0) {
        tip("请选择投票项");
        return;
      }
      commit("updateVoteLoading", true);
      return new Promise((resolve, reject) => {
        axios
          .post(baseURL + "/api/week/vote", {
            term_id: id,
            candidates: JSON.stringify(multyChecked),
          })
          .then((res) => {
            commit("updateVoteLoading", false);
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 1) {
                state.candidates.map((item) => {
                  item.records =
                    parseInt(item.records) + parseInt(item.my_vote);
                  return item;
                });
                // commit("updateLeftVoteNum", state.leftVoteNum - sum);
                commit("updateSelectedVoteNum", 0);
                commit("updateCanVote", false);
                commit("initialCandidates", state.candidates);

                const userAgentString = navigator.userAgent.toLowerCase();
                if (userAgentString.indexOf("zsrbapp") >= 0) {
                  tip("投票成功");
                  resolve;
                } else {
                  tip("投票成功");
                  // window.location.href =
                  // `https://zsrbactivity.zsnews.cn/vue/week_vote/#`;
                  resolve;
                  // Dialog.confirm({
                  //   title: "投票成功",
                  //   message: data.msg,
                  //   theme: "round-button",
                  //   cancelButtonText: "关闭",
                  //   confirmButtonText: "前往下载",
                  // }).then(() => {
                  //   window.location.href = "http://www.zsnews.cn/app/mobile.html";
                  // });
                }
              } else {
                tip(data.msg);
                reject;
              }
            } else {
              tip("网络错误, 请稍后再试");
              reject;
            }
          })
          .catch(function (error) {
            commit("updateVoteLoading", false);
            reject;
            if (error.response.status == 401) {
              tip("请先登录");
            } else {
              tip("网络错误, 请稍后再试");
            }
          });
      });
    },
    getZsplusJsBrigde({ commit }) {
      return new Promise((resolve) => {
        axios
          .get(baseURL + "/api/common/zsrbjsbrigeconfig")
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 1) {
                commit("updateJsBridgePackage", data.data);
                resolve(data.data);
              } else {
                tip(data.msg);
              }
            } else {
              tip("网络错误，请重试");
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
          });
      });
    },
    loginByZsplus({ commit }, info) {
      return new Promise((resolve) => {
        axios
          .post(baseURL + "/api/common/zsplusauth", {
            sessionToken: info.sessionToken,
            head: info.head,
            nickName: info.nickName,
            phone: info.phone,
            gender: info.gender,
          })
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code == 1) {
                // 存储中山+授权用户信息
                commit("updateUser", data.data);
                sessionStorage.setItem("zsplusInfo", JSON.stringify(data.data));
                resolve();
              } else if (data.code == 2) {
                //sessionToken过期,需要配合iOS端做统一处理
                tip(data.msg);
              } else {
                tip(data.msg);
              }
            } else {
              tip("网络错误，请重试");
            }
          });
      });
    },
    //要改为post
    loginByWx({ commit }, code) {
      return new Promise((resolve) => {
        axios
          .get("https://zsrbactivity.zsnews.cn/api/common/wechatauth", {
            params: { code },
          })
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code == 1) {
                if (data.data) {
                  // 存储微信授权用户信息
                  commit("updateUser", data.data);
                  sessionStorage.setItem("wxInfo", JSON.stringify(data.data));
                  resolve();
                } else {
                  tip(data.msg);
                }
              } else {
                tip(data.msg);
              }
            }
          })
          .catch((err) => {
            console.log("err", err);
            tip("网络错误，请重试");
          });
      });
    },
    //登录
    vote({ commit, state }) {
      // if (!state.checked.length) {
      //   tip("请选择候选人");
      //   return;
      // }
      if (state.checked.length > state.leftVoteNum) {
        tip("不好意思，票数不够");
        return;
      }
      const candidates = state.checked.join(",");
      // const params = {
      //   teachers: teacherList.join(","),
      //   token: state.user.token,
      // };
      commit("updateVoteLoading", true);
      axios
        .post(baseURL + "/api/week/vote", {
          candidates: candidates,
        })
        .then((res) => {
          commit("updateVoteLoading", false);
          if (res.status === 200) {
            const data = res.data;
            if (data.code === 1) {
              state.candidates.map((item) => {
                if (state.checked.indexOf(item.id) >= 0) {
                  item.records++;
                  return item;
                }
                return item;
              });
              commit(
                "updateLeftVoteNum",
                state.leftVoteNum - state.checked.length
              );
              commit("updateChecked", []);
              tip(data.msg);
            } else {
              tip(data.msg);
            }
          } else {
            tip(res.data.msg);
          }
        })
        .catch(function (error) {
          commit("updateVoteLoading", false);
          if (error.response.status == 401) {
            tip("请先登录");
          }
        });
    },
  },
  modules: {},
});
